<template>
  <img class="rank-image" :src="rankUrl" v-if="user" />
</template>

<script>
export default {
  name: 'UserRank',
  props: {
    user: {
      type: Object,
    },
  },
  computed: {
    rankUrl() {
      if (this.user.won / 3 > 3) {
        return '/static/images/rank_2.svg';
      } else if (this.user.won / 3 >= 2) {
        return '/static/images/rank_1.svg';
      }
      return '/static/images/rank_0.svg';
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
